.wrapper {
  position: relative;
  top: 3px;
}

.icon {
  margin-left: var(--space-1);
  cursor: pointer;
  transform: translateY(0.5px);
}